import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { getImageUrl } from "./ProductCard";

export function CategoryShowcaseGrid({ section }) {
  const cards = section.categoryGridCards || [];
  if (!cards.length) return null;

  return (
    <section className="container mx-auto px-4 lg:px-8 py-10">
      {section.title && (
        <h2 className="text-2xl sm:text-3xl font-display font-bold tracking-tight text-foreground mb-8">
          {section.title}
        </h2>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((card, idx) => (
          <div
            key={idx}
            className="flex items-stretch bg-surface rounded-xl border border-border overflow-hidden min-h-[140px] hover:border-primary/40 hover:shadow-card-hover transition-all"
          >
            <div className="w-28 sm:w-36 aspect-square shrink-0 flex items-center justify-center p-3 bg-white">
              {card.image ? (
                <img
                  src={getImageUrl(card.image)}
                  alt={card.title}
                  className="max-h-full max-w-full object-contain"
                  loading="lazy"
                />
              ) : (
                <div className="w-16 h-16 bg-muted rounded-lg" />
              )}
            </div>
            <div className="flex-1 p-4 flex flex-col justify-center">
              <h3 className="font-bold text-lg text-foreground mb-2">{card.title}</h3>
              <ul className="space-y-1 mb-2">
                {(card.links || []).map((link, li) => (
                  <li key={li}>
                    {link.url ? (
                      link.url.startsWith("http") ? (
                        <a
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm text-muted-foreground hover:text-primary transition-colors"
                        >
                          {link.label}
                        </a>
                      ) : (
                        <Link
                          to={link.url}
                          className="text-sm text-muted-foreground hover:text-primary transition-colors"
                        >
                          {link.label}
                        </Link>
                      )
                    ) : (
                      <span className="text-sm text-muted-foreground">{link.label}</span>
                    )}
                  </li>
                ))}
              </ul>
              {card.shopMoreLink && (
                <Link
                  to={card.shopMoreLink}
                  className="inline-flex items-center gap-1 text-sm font-semibold text-primary hover:underline mt-auto"
                >
                  Shop More <ChevronRight className="h-4 w-4" />
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
